<template>
<div >
    <div class="filters" v-for="(item, index) in filtersItems" :key="index">
        <div class="filter">
            <div class="icon-util" :class="[radioCurrent==index?'check-radio':'radio']" style="float:left" @click="toggleBox(index)"></div>
            <span class="check-item-position" @click="toggleBox(index)">{{item.name}}</span>
        </div>
        <transition name="slide">
            <div v-show="radioCurrent==index" class="ignore-boxs">
                <div>
                    <input :style="{width:getInputWidth()}"   @keyup.enter="addToFilterList"  class="ignore-input" v-model="inputValue" :placeholder="$t('language.common.filterHolder')"/>
                    <button class="add-ignores" @click="addToFilterList" >{{$t('language.common.add')}}</button>
                </div>
                <div :data-title="$t('language.popup.cloudTransferPopup.cleanList')" class="icon-util broom clean-list" @click="cleanList()"></div>
                <div class="ignore-files">
                    <div class="extens" @mouseenter="canelIndex=index" @mouseleave="canelIndex=-1" v-for="(item, index) in items" :key="index" :title="item">{{item}}
                        <div class="icon-util red-cross red-cancel" v-if="canelIndex==index" @click="cleanItem(index)"></div>
                    </div>
                </div>
            </div>
        </transition>
    </div>
</div>
</template>

<script>
import commonUtils from "@/js/workspace/common_util.js";
export default {
    data: function () {
        return {
            filtersItems: [{
                    name: this.$t('language.popup.ignoreFiles')
                },
                {
                    name: this.$t('language.popup.includeFiles')
                }
            ],
            radioCurrent: 0,
            ignoreArr: [],
            includeArr: [],
            inputValue: null,
            items: [],
            canelIndex: -1,
            placeHolderValue:this.$t('language.common.filterHolder')

        };
    },
    methods: {
        getInputWidth(){
            let result;
            if (this.$i18n.locale == 'deutsch'||this.$i18n.locale == 'france'||this.$i18n.locale == 'portuguese') {
                result = 280 + 'Px';
            }
            return result;
        },
        addToFilterList() {
            //如果需要处理非法后缀在这里做判断
            // this.inputValue = commonUtils.getSuffix(this.inputValue);
            if (this.radioCurrent == 0) {
                if(this.inputValue){
                    this.includeArr=[];
                }
                this.$parent.$parent.$parent.options.pattern = Object.assign('exclude');
                let filterValue = commonUtils.matchExtension(this.inputValue);
                if (filterValue && !this.ignoreArr.includes(filterValue)) {
                    this.ignoreArr.push(filterValue);
                    this.items = this.ignoreArr;
                }
            } else if (this.radioCurrent == 1) {
                  if(this.inputValue){
                    this.ignoreArr=[];
                }
                this.$parent.$parent.$parent.options.pattern = Object.assign('include');
                let filterValue = commonUtils.matchExtension(this.inputValue);
                if (filterValue && !this.includeArr.includes(filterValue)) {
                    this.includeArr.push(commonUtils.matchExtension(this.inputValue));
                    this.items = this.includeArr;
                }
            }
            this.inputValue = null;
        },
        toggleBox(index) {
            this.radioCurrent = index;
            this.items = [];
            this.inputValue=null;
            if (index == 0) {
                this.items = this.ignoreArr;
                this.$parent.$parent.$parent.options.pattern = Object.assign('exclude');
            } else {
                this.items = this.includeArr;
                this.$parent.$parent.$parent.options.pattern = Object.assign('include');
            }
        },
        cleanList() {
            this.items = [];
            if (this.radioCurrent == 0) {
                this.ignoreArr = [];
            } else if (this.radioCurrent == 1) {
                this.includeArr = [];
            }
        },
        cleanItem(index) {
            this.items.splice(index, 1);
            if (this.radioCurrent == 0) {
                this.ignoreArr.splice(index, 1);
            } else if (this.radioCurrent == 1) {
                this.includeArr.splice(index, 1);
            }
            this.canelIndex=-1;
        }
    },
};
</script>

<style>
.red-cancel {
    position: absolute;
    top: -6px;
    /*no*/
    right:-4Px;
    cursor: pointer;
}

.clean-list {
    float: right;
}

.eg-text {
    margin: 10px 0px 0px 10px;
    /*no*/
}

.clean-list:hover:after {
    content: attr(data-title);
    position: relative;
    border: #8a96e3 solid 1px;
    /*no*/
    background: #fff;
    font-size: 13px;
    /*no*/
    color: rgba(0, 0, 0, 0.6);
    padding: 2px;
    /*no*/
    border-radius: 2px;
    /*no*/
    z-index: 200;
    width: 60px;
    /*no*/
    left: -55Px;
    top: 25Px;
    white-space: nowrap;
}

.red-back {
    background: #ff7b7b !important;
}

.green-back {
    background: #5acc9b !important;
}

.black-back {
    background: #778c9b !important;
}

.grey-back {
    background: #92a3af !important;
}

.extens {
    float: left;
    margin: 10px 0px 0px 10px;
    /*no*/
    background: #92a3af;
    font-size: 14px;
    /*no*/
    color: #fff;
    background: #5ec9ff;
    line-height: 20px;
    /*no*/
    padding: 1px 10px 1px 10px;
    /*no*/
    border-radius: 2px;
    /*no*/
    position: relative;
    max-width: 96%;
    width: fit-content;
    width: -webkit-fit-content;
    width: -moz-fit-content;
    word-wrap: break-word;
}

.slide-enter-active {
    transition: all 0.3s ease;
    height: 100px;
    /*no*/
    overflow: hidden;
}

.slide-leave-active {
    transition: all 0s ease;
    height: 0px;
    /*no*/
    overflow: hidden;
}

.slide-enter,
.slide-leave {
    height: 0;
    opacity: 0;
}

.ignore-boxs {
    margin-bottom: 30px;
    /*no*/
}

.add-ignores {
    margin-left: 5px;
    /*no*/
}

.ignore-input {
    width: 220px;
    /*no*/
    white-space: pre !important;
}

.ignore-files {
    width: 648px;
    /*no*/
    height: 110px;
    /*no*/
    border: 1px solid #cdddf5;
    /*no*/
    box-sizing: border-box;
    overflow: auto;
}

/*定义滑块，内阴影及圆角*/
.ignore-files::-webkit-scrollbar {
    width: 5px;
    /*no*/
    height: 0px;
    /*no*/
    background-color: #fff;
}

.ignore-files::-webkit-scrollbar-thumb {
    border-radius: 5px;
    /*no*/
    background-color: #becae4;
}

.filter {
    width: 100%;
    height: 30px;
    /*no*/
}
</style>



// WEBPACK FOOTER //
// src/components/common/tabs/tabs_transfer_options/tab_filter.vue